import { useNavigate, useLocation } from "react-router-dom";
import { Home, Gamepad2, ShoppingBag, User } from "lucide-react";

/**
 * Sticky Bottom Navigation — Mobile only.
 * Owner directive (Feb 2026): keep it to FOUR primary targets — Home,
 * Games, Shop, Profile. Live balance chip + Get Coins CTA lives in
 * `MobileTopBar` so the bottom bar stays uncluttered and thumb-friendly.
 */
const NAV_ITEMS = [
  { id: "home",    label: "Home",    icon: Home,        path: "/" },
  { id: "games",   label: "Games",   icon: Gamepad2,    path: "/lobby" },
  { id: "shop",    label: "Shop",    icon: ShoppingBag, path: "/store" },
  { id: "profile", label: "Profile", icon: User,        path: "/profile" },
];

export default function StickyBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (item) => {
    if (item.path === "/")      return location.pathname === "/";
    if (item.path === "/lobby") return location.pathname === "/lobby" || location.pathname === "/games";
    return location.pathname.startsWith(item.path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-[60] backdrop-blur-xl border-t md:hidden"
      style={{
        background: 'rgba(7,11,25,0.95)',
        borderColor: '#1f2a4d',
        paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 4px)',
      }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-stretch justify-around px-2 pt-1.5 pb-1.5">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = isActive(item);
          return (
            <button
              key={item.id}
              data-testid={`bottom-nav-${item.id}`}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center gap-0.5 py-2 px-3 min-h-[52px] flex-1 rounded-lg transition-all"
              style={{ color: active ? '#4d7cff' : '#6b7797' }}
            >
              <Icon className="w-6 h-6 transition-colors" strokeWidth={active ? 2.4 : 2} />
              <span className="text-[10px] font-semibold tracking-wide">{item.label}</span>
              {active && (
                <div className="w-1 h-1 rounded-full -mt-0.5" style={{ background: '#4d7cff' }} />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
